import React from 'react';
import { Link } from 'react-router-dom';

import user1 from '../../assets/images/users/1.jpg';
import user2 from '../../assets/images/users/2.jpg';
import user3 from '../../assets/images/users/3.jpg';
import user4 from '../../assets/images/users/4.jpg';
import user5 from '../../assets/images/users/5.jpg';
import user6 from '../../assets/images/users/6.jpg';

import product4 from '../../assets/images/products/04.jpg';
import product5 from '../../assets/images/products/05.jpg';
import product6 from '../../assets/images/products/06.jpg';
import product7 from '../../assets/images/products/07.jpg';
import product8 from '../../assets/images/products/08.jpg';
import product9 from '../../assets/images/products/09.jpg';
import product10 from '../../assets/images/products/10.jpg';
import product11 from '../../assets/images/products/11.jpg';
import product12 from '../../assets/images/products/12.jpg';

export default function Tables() {
    return (
        <>
            <div className='container-fluid'>
                <div className='col-12'>
                    <nav aria-label='breadcrumb'>
                        <h2 className='mb-3'>جدول معمولی</h2>

                        <ol className='breadcrumb'>
                            <li className='breadcrumb-item'>
                                <Link to='/'>جداول</Link>
                            </li>

                            <li className='breadcrumb-item'>
                                <Link to='/table'>جدول معمولی</Link>
                            </li>

                            <li
                                className='breadcrumb-item active'
                                aria-current='page'
                            >
                                شما اینجایی
                            </li>
                        </ol>
                    </nav>
                </div>

                <div className='space-20' />

                <div className='row'>
                    <div className='col-md-12 col-lg-6'>
                        <div className='card'>
                            <div className='card-body scrolled dashboard-chart-with-list'>
                                <div className='table-responsive'>
                                    <table className='table table-bordered table-striped'>
                                        <thead>
                                            <tr>
                                                <th scope='col'>نام مشتری</th>

                                                <th scope='col'>نام محصول</th>

                                                <th scope='col'>کد محصول</th>

                                                <th scope='col'>مبلغ خرید</th>

                                                <th scope='col'>شهر</th>

                                                <th scope='col'>وضعیت ارسال</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td>
                                                    <img
                                                        src={user1}
                                                        alt='user'
                                                        className='table-user'
                                                    />
                                                    امیررضا کدخدازاده
                                                </td>

                                                <td>قهوه اسپرسو</td>

                                                <td>#100946</td>

                                                <td>380،000</td>

                                                <td>کرج</td>

                                                <td>
                                                    <span className='badge badge-success'>
                                                        ارسال شد
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={user2}
                                                        alt='user'
                                                        className='table-user'
                                                    />
                                                    مهدی حسن زاده
                                                </td>

                                                <td>قهوه اسپرسو</td>

                                                <td>#100946</td>

                                                <td>730،000</td>

                                                <td>اصفهان</td>

                                                <td>
                                                    <span className='badge badge-success'>
                                                        ارسال شد
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={user3}
                                                        alt='user'
                                                        className='table-user'
                                                    />
                                                    سجاد رحمانی
                                                </td>

                                                <td>قهوه اسپرسو</td>

                                                <td>#100946</td>

                                                <td>230،000</td>

                                                <td>تهران</td>

                                                <td>
                                                    <span className='badge badge-warning'>
                                                        در انتظار تایید
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={user4}
                                                        alt='user'
                                                        className='table-user'
                                                    />
                                                    حمید خسرویان
                                                </td>

                                                <td>قهوه اسپرسو</td>

                                                <td>#100946</td>

                                                <td>100،000</td>

                                                <td>رشت</td>

                                                <td>
                                                    <span className='badge badge-danger'>
                                                        کنسل شد
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={user5}
                                                        alt='user'
                                                        className='table-user'
                                                    />
                                                    شهریار پیروز
                                                </td>

                                                <td>قهوه اسپرسو</td>

                                                <td>#100946</td>

                                                <td>400،000</td>

                                                <td>تبریز</td>

                                                <td>
                                                    <span className='badge badge-warning'>
                                                        در انتظار تایید
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={user6}
                                                        alt='user'
                                                        className='table-user'
                                                    />
                                                    خشایار مهدوی
                                                </td>

                                                <td>قهوه اسپرسو</td>

                                                <td>#100946</td>

                                                <td>560،000</td>

                                                <td>مشهد</td>

                                                <td>
                                                    <span className='badge badge-danger'>
                                                        کنسل شد
                                                    </span>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={user4}
                                                        alt='user'
                                                        className='table-user'
                                                    />
                                                    دانیال رضایی
                                                </td>

                                                <td>قهوه اسپرسو</td>

                                                <td>#100946</td>

                                                <td>560،000</td>

                                                <td>مشهد</td>

                                                <td>
                                                    <span className='badge badge-danger'>
                                                        کنسل شد
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12 col-lg-6'>
                        <div className='card'>
                            <div className='card-body scrolled dashboard-chart-with-list'>
                                <div className='table-responsive'>
                                    <table className='table table-bordered table-striped table-product'>
                                        <thead>
                                            <tr>
                                                <th scope='col'>نام محصول</th>

                                                <th scope='col'>قیمت محصول</th>

                                                <th scope='col'>تخفیف</th>

                                                <th scope='col'>تعداد فروش</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td>
                                                    <img
                                                        src={product4}
                                                        alt='user'
                                                    />
                                                    نوتلا
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={product5}
                                                        alt='user'
                                                    />
                                                    مرغ ۲ کیلویی
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={product6}
                                                        alt='user'
                                                    />
                                                    روغن زیتون
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={product7}
                                                        alt='user'
                                                    />
                                                    هدفون بی سیم
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={product8}
                                                        alt='user'
                                                    />
                                                    تلویزیون هوشمند
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={product9}
                                                        alt='user'
                                                    />
                                                    اسپیکر بی سیم
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={product10}
                                                        alt='user'
                                                    />
                                                    ساعت هوشمند
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={product11}
                                                        alt='user'
                                                    />
                                                    سویشرت
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <img
                                                        src={product12}
                                                        alt='user'
                                                    />
                                                    عینک آفتابی
                                                </td>

                                                <td>350،000 تومان</td>

                                                <td>50،000 تومان</td>

                                                <td>178</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
